var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"top-right-bg",attrs:{"src":require("@/assets/top_right_bg.png"),"alt":""}}),_c('HeaderComponent',{staticClass:"container"}),_c('router-view'),_c('GetInTouch',{staticClass:"container"}),_c('FooterComponent',{})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }